import { API } from '../core/api';

type OrderInfo = {
    dateCreate: string;
    name: string;
    state: string;
    dataTsp: Record<string, any>;
    taxNumber: string;
    russian_trade_name: string;
    sberpayAvailable: boolean;
    sbpAvailable: boolean;
    qrCurrency: string;
};

type CreateOrderRequest = {
    qrCodeId: number;
    amount: number;
    name: string;
    quantity: number;
};

export class OrderApi extends API {
    static getOrderInfo(qrCodeId: number) {
        return this.get<OrderInfo>(`/ca/tsp/order/static-qr?qrCodeId=${qrCodeId}`);
    }

    static createOrder(data: CreateOrderRequest) {
        return this.post<{ idOrder: number }>('/ca/tsp/order/static-qr', data);
    }
}
